import { useParams } from 'react-router'

export const useRegisteredTenant = () => {
  const { registeredTenantId } = useParams<{
    registeredTenantId: string
  }>()

  return registeredTenantId
}
